import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { Label } from '@cian/ui-kit';
import { IconProductHighDemand16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { LabelsLayout, TooltipLabel } from '../../components/Labels';
import {
  getIsEscrow,
  getDiscountMortgage,
  getReliableLabel,
  getNewbuildingBrokerBookingAvailable,
} from '../../selectors/newbuilding';
import { trackLabelClick } from './tracking';
import { ReliableLabel } from '../../components/Labels/ReliableLabel';

export function LabelsContainer() {
  const hasDiscountMortgage = useSelector(getDiscountMortgage);
  const isEscrow = useSelector(getIsEscrow);
  const reliableLabel = useSelector(getReliableLabel);
  const isBrokerBookingAvailable = useSelector(getNewbuildingBrokerBookingAvailable);

  const onLabelClick = (anchor: string, label: string) => (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor,
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackLabelClick(label);
  };

  return (
    <LabelsLayout>
      {hasDiscountMortgage && (
        <TooltipLabel
          background="decorative-purple"
          color="theme-white"
          icon={<IconProductHighDemand16 color="icon-inverted-default" />}
          text="Льготная ипотека"
          tooltipText={
            <>
              Подробнее узнавайте <br /> у застройщика
            </>
          }
        />
      )}
      {reliableLabel && (
        <ReliableLabel
          label={reliableLabel.title}
          reliableType={reliableLabel.type}
          onReliableClick={onLabelClick('#reliable', 'tab_reliable_dev')}
          onProblemClick={onLabelClick('#reliable', 'tab_problem_building')}
        />
      )}
      {isEscrow && (
        <TooltipLabel
          text="Эскроу"
          background="accent-main-secondary"
          color="accent-main-primary"
          tooltipText="Подробнее об эскроу–счёте"
          onClick={onLabelClick('#escrow', 'tab_escrow')}
        />
      )}
      {isBrokerBookingAvailable && (
        <Label color="accent-main-primary" background="accent-main-secondary">
          Онлайн-бронирование
        </Label>
      )}
    </LabelsLayout>
  );
}
